export const getRandomNumber = ({ min, max }) => {
  return Math.floor(Math.random() * max) + min
}
